/**
 * Author: Claude Code
 * Generation: i18n configuration with language detection
 * Version: v3.2.54
 * Modified: 2025-10-09
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  // Load translation using http backend
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Default language
    fallbackLng: 'zh',
    // Supported languages
    supportedLngs: ['en', 'zh'],

    // Debug mode in development
    debug: false,

    // Language detection options
    detection: {
      // Order of detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage'],
    },

    // Backend options
    backend: {
      // Path to load resources from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // React options
    react: {
      // Wait for all translations to be loaded before rendering
      useSuspense: false,
    },

    // Interpolation options
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },

    // Namespace
    ns: ['translation'],
    defaultNS: 'translation',
  });

export default i18n;
